export const ENCRYPTION_PROVIDER_COMPONENT_NAME = "<EncryptionProvider>";
export const ENCRYPTION_TYPE = "JWT";
export const MAXIMUM_NUMBER_OF_ENCRYPTION_ATTEMPTS = 5;
export const MAXIMUM_NUMBER_OF_RETRIES = 4;
